import styles from "./PayPalModal.module.scss";
import close from "../../../assets/icons/close.svg";
import Button from "../../button/Button";
import processing from "../../../assets/icons/processing.svg";
import { useTranslation } from "react-i18next";

interface PayPalModalProps {
  setIsUpdatePayPalVisible: (arg: boolean) => void;
}

const PayPalModal: React.FC<PayPalModalProps> = ({
  setIsUpdatePayPalVisible,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>{t("PayPal Window Opened")}</p>
        <img
          src={close}
          alt="close"
          onClick={() => setIsUpdatePayPalVisible(false)}
          className={styles.root_header_img}
        />
      </div>
      <p className={styles.root_subtitle}>
        {t(
          "We've opened a PayPal window in another tab. Please log in to your PayPal account and update your payment method."
        )}
      </p>
      <div className={styles.root_main}>
        <img src={processing} alt="processing" />
        <div className={styles.root_main_message}>
          <p>{t("Paypal not loading?")}</p>
          <p>
            <a href="/">{t("Click here")}</a> {t("to go to Paypal")}
          </p>
        </div>
      </div>
      <Button
        onClick={() => setIsUpdatePayPalVisible(false)}
        text={t("Close")}
        type="default"
        classNames={styles.root_button}
      />
    </div>
  );
};

export default PayPalModal;
